<template>
  <v-stepper v-model="currentStep" show-actions class="elevation-0">
    <v-stepper-header class="elevation-0">
      <v-stepper-item
        :value="1"
        :color="!!newItem.Type ? 'success' : 'primary'"
        :complete="!!newItem.Type"
      >
        <span v-if="newItem.Type">
          Inventory Type: {{ newItem.Type.name }}
        </span>
        <span v-else> Inventory Type </span>
      </v-stepper-item>

      <v-divider />
      <v-stepper-item
        :value="2"
        :editable="!!newItem.Type && !(!!created && !!created.tag)"
        :complete="(!!newItem.PSpot || !!newItem.Website) && currentStep > 2"
        :color="!!newItem.PSpot || !!newItem.Website ? 'success' : 'primary'"
        :rules="
          currentStep < 2
            ? undefined
            : [() => !!specsForm || 'Please select a fill in Specs']
        "
      >
        Specifications
      </v-stepper-item>
      <v-divider />
      <v-stepper-item
        :value="3"
        :editable="!!newItem.Type && !(!!created && !!created.tag)"
        :complete="!!newItem.Settings && currentStep > 3"
        :color="!!newItem.Settings && settingsForm ? 'success' : 'primary'"
        :rules="
          currentStep < 3
            ? undefined
            : [() => !!specsForm || 'Please select a fill in Specs']
        "
      >
        Settings
      </v-stepper-item>
      <v-divider />
      <v-stepper-item
        :value="4"
        :editable="false"
        :complete="!!created && !!created.tag"
        :color="!!newItem.PSpot || !!newItem.Website ? 'success' : 'primary'"
      >
        Code
      </v-stepper-item>
    </v-stepper-header>

    <v-stepper-window>
      <v-stepper-window-item :value="1">
        <AdPlacementTypeSelector
          ref="TypeSelector"
          v-model="newItem.Type"
          @next="next"
        />
      </v-stepper-window-item>

      <v-stepper-window-item :value="2">
        <v-form
          v-model="specsForm"
          validate-on="input"
          fast-fail
          @update:model-value="
            (v) => (v === null ? (specsForm = true) : (specsForm = v))
          "
        >
          <!-- this is a fast-hack to make it real, from some reason form returns null during initialization...  -->
          <SkyscraperSpecs
            v-if="newItem.Type && newItem.Type.code === 'BANNER'"
            v-model="newItem.Website"
            @next="next"
          />
          <BannerSpecs
            v-else-if="newItem.Type && newItem.Type.code === 'SKYSCRAPER'"
            v-model="newItem.Website"
            @next="next"
          />
          <BannerSpecs
            v-else-if="newItem.Type && newItem.Type.code === 'P_SPOT'"
            v-model="newItem.Website"
            @next="next"
          />
        </v-form>
      </v-stepper-window-item>
      <v-stepper-window-item :value="3">
        <v-form
          v-model="settingsForm"
          validate-on="input"
          fast-fail
          @update:model-value="
            (v) => (v === null ? (settingsForm = true) : (settingsForm = v))
          "
        >
          <AdPlacementSettings v-model="newItem.Settings" />
        </v-form>
      </v-stepper-window-item>
      <v-stepper-window-item :value="4">
        <AdPlacementCodePreview :model-value="created.tag" />
      </v-stepper-window-item>
    </v-stepper-window>
    <v-stepper-actions
      :disabled="disabled"
      @click:next="next"
      @click:prev="prev"
    >
      <template #next>
        <v-btn
          :disabled="!isStepValid(currentStep)"
          @click.prevent.stop="next"
          color="primary"
        >
          <span
            v-if="currentStep === 3"
            class="d-flex align-center justify-center"
          >
            Submit
          </span>
          <span
            v-else-if="currentStep === 4"
            class="d-flex align-center justify-center"
          >
            Copy & Close
          </span>
          <span v-else> Next </span>
        </v-btn>
      </template>
    </v-stepper-actions>
  </v-stepper>
</template>
  
  
  <script>
import AdPlacementSettings from "@/components/molecules/adPlacement/AdPlacementSettings.vue";
import AdPlacementCodePreview from "../../molecules/adPlacement/AdPlacementCodePreview.vue";
import AdPlacementTypeSelector from "../../molecules/adPlacement/AdPlacementTypeSelector.vue";
import BannerSpecs from "../../molecules/adPlacement/BannerSpecs.vue";
import SkyscraperSpecs from "../../molecules/adPlacement/SkyscraperSpecs.vue";

export default {
  components: {
    AdPlacementTypeSelector,
    SkyscraperSpecs,
    BannerSpecs,
    AdPlacementCodePreview,
    AdPlacementSettings,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    created: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["submit"],
  data() {
    return {
      currentStep: 1,

      specsForm: true,
      settingsForm: true,

      newItem: {
        name: null,
        PSpot: null,
        Settings: null,
        Website: null,
        Type: null,
      },
    };
  },
  computed: {
    disabled() {
      return this.currentStep === 1
        ? "prev"
        : this.currentStep === 4
        ? "next"
        : undefined;
    },
  },
  watch: {
    created(newVal) {
      if (newVal && newVal.tag) this.currentStep++;
    },
  },
  methods: {
    isStepValid(step) {
      switch (step) {
        case 1:
          return !!this.newItem.Type;

        case 2:
          return (
            (!!this.newItem.Website || !!this.newItem.PSpot) && this.specsForm
          );

        case 3:
          return !!this.newItem.Settings && this.settingsForm;
        case 4:
          return !!(this.created && this.created.tag);
        default:
          return true;
      }
    },
    prev() {
      this.currentStep--;
    },
    next() {
      if (this.isStepValid(this.currentStep) && this.currentStep < 3)
        this.currentStep++;
      else if (this.currentStep === 3) {
        console.log("submit");
        this.$emit("submit", this.newItem);
      }
    },
    reset() {
      this.currentStep = 1;
      this.newItem = {
        Type: null,
        name: null,
        description: null,
      };
    },
  },
};
</script>